import {Action} from '@ngrx/store';
import {Order} from '../models/order';
import {type} from '../../shared';

export const orderActionTypes = {
  LOAD: type('[order] Load'),
  LOAD_SUCCESS: type('[order] Load Success'),
  LOAD_FAIL: type('[order] Load Fail'),
  CLEAR: type('[order] Clear'),
  LOAD_FAIL_GONE: type('[order] Load Fail Gone'), // TODO: don't change this type because used in order-detail.component
};

export class LoadOrderAction implements Action {
  readonly type = orderActionTypes.LOAD;
  constructor(public payload?: string) {}
}

export class LoadOrderSuccessAction implements Action {
  readonly type = orderActionTypes.LOAD_SUCCESS;
  constructor(public payload?: Order) {}
}

export class LoadOrderFailAction implements Action {
  readonly type = orderActionTypes.LOAD_FAIL;
  constructor(public payload?: number) {}
}

export class OrderClearAction implements Action {
  readonly type = orderActionTypes.CLEAR;
  constructor() {}
}

export class OrderGoneAction implements Action {
  readonly type = orderActionTypes.LOAD_FAIL_GONE;
  constructor(public payload?: number) {}
}

